/*
 * File: CustomViewTask.tsx
 * Project: a-a
 * File Created: Thursday, 20th February 2025 9:43:57 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 15th September 2025 11:09:00 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { memo, useCallback, useEffect, useState } from 'react';
import CustomDrawer from '../CustomDrawer/CustomDrawer';
import { Box, Chip, Divider, LinearProgress, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../theme/Color';
import dayjs from 'dayjs';
import CustomDragnDrop from '../CustomDragnDrop/CustomDragnDrop';
import SubtaskCard from '../CustomSubtaskCard/CustomSubtaskCard';
import { Constants } from '../../../utilities/constants';
import CustomAddTask from '../CustomAddTask/CustomAddTask';
import { LightTooltip } from '../CustomTooltip/CustomTooltip';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import CustomButton from '../CustomButton/CustomButton';
import { Link, useLocation } from 'react-router-dom';
import { SFService } from '../../../service/SF.service';
import CustomModal from '../CustomModal/CustomModal';
import CustomCard from '../CustomCard/CustomCard';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';
import CustomNotes from '../CustomNotes/CustomNotes';
import style from './CustomViewTask.module.css';

const CustomViewTask = ({
  setDrawerState,
  drawerState,
  selectedData,
  setEditDone,
  setDeleted,
  setSelected,
}: {
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  drawerState: boolean;
  selectedData: any;
  setEditDone: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleted: React.Dispatch<React.SetStateAction<string>>;
  setSelected: React.Dispatch<
    React.SetStateAction<{
      assignedTo: string;
      createdDate: string;
      decription: string;
      dueDate: string;
      isOverdue: boolean;
      link: string;
      name: string;
      nameType: string;
      priority: string;
      relatedTo: string;
      relatedToType: string;
      status: string;
      subject: string;
      id: string;
    }>
  >;
}) => {
  const sf_edit_selected = sessionStorage.getItem('sf_edit_selected') || '';
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const sf_marked = sessionStorage.getItem('sf_marked') || '';
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  let parse_sf = {
    access_token: '',
    id: '',
    instance_url: '',
    issued_at: '',
    refresh_token: '',
    scope: '',
    signature: '',
    token_type: '',
  };
  if (sf_token) {
    parse_sf = JSON.parse(sf_token);
  }
  const location = useLocation();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selectedChip, setSelectedChip] = useState('Subtask');
  const [selectedFiles, setSelectedFiles] = useState<File[]>(
    selectedData && selectedData?.attachments ? [...selectedData?.attachments] : [],
  );
  // console.log([...selectedData?.attachments]);
  const [openModal, setOpenModal] = React.useState(false);
  const [msg, setMsg] = useState<{ message: string; type: 'Error' | 'Success' }>({
    message: '',
    type: 'Success',
  });
  useEffect(() => {
    setSelectedFiles([...selectedData?.attachments]);
  }, [selectedData?.attachments]);
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setSelectedFiles([...selectedData?.attachments]);
    console.log('onClose', open, drawerState);
    setDrawerState(open);

    // setDeleted(true);
    sessionStorage.removeItem('openTask');
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_task_status');
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit_selected');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
    sessionStorage.removeItem('notes_id');
    sessionStorage.removeItem('notes_content');
  };
  console.log({ drawerState });

  const handleAlertClose = () => {
    setMsg({ message: '', type: 'Success' });
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelected({
      assignedTo: '',
      createdDate: '',
      decription: '',
      dueDate: '',
      isOverdue: true,
      link: '',
      name: '',
      nameType: '',
      priority: 'Normal',
      relatedTo: '',
      relatedToType: '',
      status: 'Not Started',
      subject: '',
      id: '',
    });
    sessionStorage.removeItem('openTask');
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_delete');
    sessionStorage.removeItem('sf_marked');
    sessionStorage.removeItem('sf_edit_selected');
  };
  const onDrop = useCallback((acceptedFiles: File[]) => {
    // Do something with the files
    console.log(acceptedFiles);
    setSelectedFiles((prev) => [...prev, ...acceptedFiles]);
  }, []);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      console.log(event.target.files, Array.from(event.target.files));
      onDrop(Array.from(event.target.files));
    }
  };
  const deleteFile = (index: number) =>
    setSelectedFiles(selectedFiles.filter((_, ind) => ind !== index));
  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };
  const selectChip = (val: string) => {
    setSelectedChip(val);
  };

  let selected = selectedData;

  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [action, setAction] = useState('');

  const handleTaskCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      setEdit(true);
      // console.lo
    } else {
      setTaskAnchorEl(event.currentTarget);
      setAction('edit');
    }
  };
  const handleDeleteClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      handleOpen();
    } else {
      setTaskAnchorEl(event.currentTarget);
      setAction('delete');
    }
  };

  useEffect(() => {
    if (sf_edit === 'true' && sf_token === 'true' && !edit) {
      setEdit((prev) => !prev);
    } else if (sf_delete === 'true' && sf_token === 'true' && !openModal) {
      handleOpen();
    } else if (
      sf_marked === 'true' &&
      sf_token === 'true' &&
      !openModal &&
      sf_edit_selected &&
      JSON.parse(sf_edit_selected || '')?.id === selected?.id
    ) {
      handleOpen();
    }
  }, [sf_edit, sf_token, sf_delete, sf_marked]);

  const openTask = Boolean(taskAnchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;
  const [anchorEl, setAnchorEl] = React.useState<HTMLImageElement | null>(null);
  const [copy, setCopy] = useState('');
  const handleCopyLink = (val: any) => {
    // console.log() .
    navigator.clipboard.writeText(val);
    setCopy('Link Copied');
    setMsg({ message: `Link Copied`, type: 'Success' });
  };
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const deleteTask = async (id: string) => {
    setLoading(true);
    try {
      const res = await SFService.deleteTask(
        id,
        //   {
        //   data: { access_token: parse_sf.access_token },
        // }
      );
      setOpenModal(false);
      // onClose(false)();
      sessionStorage.removeItem('openTask');
      sessionStorage.removeItem('sf_delete');
      setDrawerState(false);
      setDeleted('removed');
      // setMsg({ message: `Task '${selected?.subject}' deleted successfully`, type: 'Success' });
      console.log(res);
    } catch (err) {
      setMsg({ message: `Task cannot be deleted`, type: 'Error' });
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const [markAsDone, setMarkasDone] = useState(false);
  const handleOpen = () => setOpenModal((prev) => !prev);
  const handleTaskEditClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      setMarkasDone(true);
      handleOpen();
      // setAnchorEl(null);
      // console.lo
    } else {
      setTaskAnchorEl(event.currentTarget);
      setAction('markAsDone');
    }
  };
  const confirmMark = async (data: any) => {
    try {
      console.log('done');
      setLoading(true);
      const res = await SFService.editTask(data?.id, {
        // access_token: parse_sf?.access_token,
        Subject: data?.subject,
        OwnerId: data?.assignTo?.Id,
        //  recordTypeName: taskTypeSelected,
        ActivityDate: data?.date,
        ...(data?.comments && {
          Description: data?.comments,
        }),
        // ...(selectedItems.related[0]?.Id && { whatId: selectedItems.related[0]?.Id }), // parse_sf?.access_token,
        // ...(selectedItems.related[0]?.Id && { WhatId: selectedItems.related[0]?.Id }),
        // notes: comment,

        Status: 'Done',
        Priority: Array.isArray(data?.priority) ? data?.priority[0] : data?.priority,
        // ...(selectedItems.name[0].Id && { WhoId: selectedItems.name[0].Id }),
        // // ...(selectedItems.nameType && { nameType: selectedItems.nameType[0] }),
        // ...(link && { GD_Link__c: link }),
        // ...((attachments?.added?.length || attachments?.removed?.length) && {
        //   attachments: attachments,
        // }),
        // noteContent: 'test note content',
        // noteTitle: 'test note title',
      });

      handleClose();
      sessionStorage.removeItem('sf_edit_selected');
      sessionStorage.removeItem('sf_redirect');
      sessionStorage.removeItem('sf_task_status');
      setDeleted('moved');
      setMsg({ message: `Marked as done successfully.`, type: 'Success' });
    } catch (err: any) {
      console.log(err);
      setMsg({ message: err?.response?.data?.error, type: 'Error' });
      // setAlert(err?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return edit ? (
    <CustomAddTask
      handleContinueAdd={() => {}}
      handleModalClose={() => {}}
      modalOpen={false}
      setDrawerState={setDrawerState}
      drawerState={drawerState}
      edit={edit}
      setEdit={setEdit}
      setEditDone={setEditDone}
      data={selected}
    />
  ) : (
    <CustomDrawer state={drawerState} onClose={onClose(false)}>
      <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative', overflowY: 'scroll' }}>
        <Box
          sx={{ position: 'sticky', top: 0, backgroundColor: zeplinColor.Neutral1, zIndex: '1' }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '10px', xl: '16px' },
                alignItems: 'center',
                // justifyContent: 'space-between',
                // padding: '40px 24px 24px 24px',
              }}
            >
              {selected?.status !== 'Completed' && (
                <img
                  src={'/assets/mark-as-read.png'}
                  className={style['icon']}
                  alt='mark-read'
                  style={{ cursor: 'pointer' }}
                  onClick={handleTaskEditClick}
                />
              )}
              <img
                src={'/assets/copy-view.png'}
                className={style['icon']}
                alt='copy'
                style={{ cursor: 'pointer' }}
                onClick={() => handleCopyLink(selected?.link)}
              />
              {/* <img
              src={'/assets/share.svg'}
              width={'24px'}
              height={'24px'}
              alt='close'
              style={{ cursor: 'pointer' }}
              //   onClick={OnClickSubTask}
            /> */}
              <img
                src={'/assets/edit.svg'}
                className={style['icon']}
                alt='edit'
                style={{ cursor: 'pointer' }}
                onClick={handleTaskCreateClick}
              />
              <img
                src={'/assets/delete.svg'}
                className={style['icon']}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={handleDeleteClick}
              />
              {/* <img
              src={'/assets/vertical-dots.svg'}
              width={'24px'}
              height={'24px'}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={handleClick}
            /> */}
            </Box>
            <img
              src={'/assets/close-icon.svg'}
              className={style['icon']}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={onClose(false)}
            />
          </Box>
          <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
          />
        </Box>
        <CustomPopOver
          setAnchorEl={setTaskAnchorEl}
          anchorEl={taskAnchorEl}
          id={idTask}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            // marginRight: '2rem',
            // marginLeft: '-4rem',
          }}
        >
          <Box
            sx={{
              height: '202px',
              width: '340px',
              padding: '24px',
              display: 'flex',
              gap: '32px',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: '6px', xl: '12px' },
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Authentication Required
                </Typography>
                <img
                  src={'/assets/close-icon.svg'}
                  className={style['icon']}
                  alt='close'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setTaskAnchorEl(null);
                  }}
                />
              </Box>

              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                {/* To create a new task, please ensure you're logged in to your Salesforce account. */}
                You need to be logged into Salesforce to perform this action. Please log in to your
                Salesforce account.
              </Typography>
            </Box>
            <Link
              // target='_blank'
              // rel='noopener noreferrer'
              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
            >
              <CustomButton
                disabled={false}
                onClick={() => {
                  setOpenModal(false);
                  setEdit(false);
                  sessionStorage.setItem('sf_redirect', 'Task');
                  sessionStorage.setItem('sf_edit_selected', JSON.stringify(selected));
                  sessionStorage.setItem('sf_task_status', selected?.status);
                  sessionStorage.setItem('sf_path', location?.pathname);
                  action === 'edit'
                    ? sessionStorage.setItem('sf_edit', 'true')
                    : action === 'markAsDone'
                    ? sessionStorage.setItem('sf_marked', 'true')
                    : sessionStorage.setItem('sf_delete', 'true');
                }}
                variant='contained'
                color={'primary'}
                style={{
                  width: '155px',
                  borderRadius: '14px',
                  height: '48px',
                  padding: '14px 16px',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Open Salesforce'}
                // tabindex={4}
              />
            </Link>
          </Box>
        </CustomPopOver>
        {/* <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px' }}>
            <Box
              sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
              onClick={() => deleteTask(selected?.id)}
            >
              <img src={'/assets/copy-link.svg'} width={18} height={18} />
              <Typography variant='body3' color={zeplinColor.BasicBlack}>
                Delete
              </Typography>
            </Box>
          </Box>
        </CustomPopOver> */}

        {/* <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} /> */}
        <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
          <Box sx={{ display: 'flex', gap: { xs: '16px', xl: '24px' }, flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', gap: { xs: '16px', xl: '32px' }, flexDirection: 'column' }}>
              <Box
                sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}
              >
                <Box
                  sx={{ display: 'flex', gap: { xs: '4px', xl: '8px' }, flexDirection: 'column' }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
                      Created{' '}
                      {selected?.createdDate
                        ? dayjs(selected.createdDate).format('D MMM, YYYY [at] h:mm A')
                        : 'NA'}
                    </Typography>
                    <a
                      href={selected?.link}
                      style={{ textDecoration: 'none' }}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '8px',
                          width: '100%',
                          alignItems: 'center',
                          flex: 1,
                          justifyContent: 'flex-end',
                          cursor: 'pointer',
                        }}
                        // onClick={OnClickSubtask}
                        //   onClick={openInput}
                      >
                        <Typography variant='responsiveButtonSmall' color={zeplinColor.Brand1}>
                          Salesforce
                        </Typography>
                        <img
                          width={'18px'}
                          height={'18px'}
                          src={'/assets/link-blue.svg'}
                          alt='logo'
                          style={{ objectFit: 'fill' }}
                        />
                      </Box>
                    </a>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Chip
                      label={
                        <Typography
                          variant='responsiveLabel1'
                          color={zeplinColor.BasicBlack}
                          sx={{
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {selected?.recordTypeName || ''}
                        </Typography>
                      }
                      sx={{
                        backgroundColor: zeplinColor.Neutral4,

                        borderRadius: '50px',
                        // width: '47px',
                        marginTop: '8px',
                        height: '22px',
                        '&.MuiChip-root': {
                          // flex: 1,
                          padding: '4px 8px',
                        },
                        '& .MuiChip-label': {
                          // flex: 1,
                          padding: 0,
                        },
                      }}
                    />
                  </Box>
                  <Typography variant='responsiveDisplay5' color={zeplinColor.BasicBlack}>
                    {selected?.subject || 'NA'}
                  </Typography>
                </Box>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  {selected?.comments || ''}
                </Typography>
              </Box>

              <Box
                sx={{ display: 'flex', gap: { xs: '20px', xl: '24px' }, flexDirection: 'column' }}
              >
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/user-multiple.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Assignee
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Box sx={{ display: 'flex', gap: '4px', flex: 1, alignItems: 'center' }}>
                      <Box
                        sx={{
                          borderRadius: '100px',
                          padding: '10px',
                          width: '26px',
                          height: '26px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: zeplinColor.Brand1,
                        }}
                      >
                        <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                          {selected?.assignedTo?.Id
                            ? selected?.assignedTo?.Name?.split(' ').map(
                                (value: any, index: number) =>
                                  selected?.assignedTo?.Name &&
                                  (index === 0 ||
                                    index === selected?.assignedTo?.Name?.split(' ').length - 1)
                                    ? value[0]
                                    : '',
                              )
                            : 'N/A'}
                        </Typography>
                      </Box>
                      <Typography variant='responsiveBody2'>
                        {selected?.assignedTo?.Id ? selected?.assignedTo?.Name : 'N/A'}
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/type-logo.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Related Type
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {selected?.relatedToType ? selected?.relatedToType : 'N/A'}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/account.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Related To
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {selected?.relatedTo?.Id ? selected?.relatedTo?.Name : 'N/A'}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/type-logo.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Name Type
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {selected?.nameType ? selected?.nameType : 'N/A'}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/user-single.svg'
                    width={20}
                    height={20}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Name
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {selected?.name?.Id ? selected?.name?.Name : 'N/A'}
                    </Typography>
                  )}
                </Box>
                {selected?.recordTypeName === 'Payment Task' && (
                  <>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/payee.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Payee
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {selected?.payee?.Id ? selected?.payee?.Name : 'N/A'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/qty.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        QTY
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='body2' sx={{ flex: 1 }}>
                          {selected?.qty ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/rate.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Rate
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {selected?.rate ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Amount
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {selected?.amount ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/terms.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Terms
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {selected?.terms ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/email.svg'
                        className={style['field-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Email
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {selected?.email ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </>
                )}
                <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                  <img
                    src='/assets/status.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Status
                  </Typography>
                  <Box sx={{ flex: 1 }}>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Chip
                        label={
                          <Typography
                            variant='responsiveLabel1'
                            color={zeplinColor.Neutral1}
                            sx={{
                              textAlign: 'center',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {selected?.status ?? 'N/A'}
                          </Typography>
                        }
                        sx={{
                          backgroundColor: zeplinColor.BasicBlack,
                          padding: '5px 14px 5px 14px',
                          borderRadius: '50px',
                          // width: '47px',
                          height: '29px',
                          '&.MuiChip-root': {
                            // flex: 1,
                          },
                          '& .MuiChip-label ': {
                            padding: 0,
                          },
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'centers' }}>
                  <img
                    src='/assets/priority.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Priority
                  </Typography>
                  <Box sx={{ flex: 1 }}>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Chip
                        label={
                          <Typography variant='responsiveLabel1'>{selected?.priority}</Typography>
                        }
                        sx={{
                          bgcolor:
                            Constants.PriorityTask[
                              (selected?.priority || 'Medium') as 'Normal' | 'Low' | 'High'
                            ],
                          color: zeplinColor.Neutral1,
                          // width: '39px',
                          '&.MuiChip-root': {
                            height: '29px',
                            padding: '4px 14px',
                            borderRadius: '50px',
                          },
                          '& .MuiChip-label': {
                            padding: 0,
                          },
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/calendar-fade.svg'
                    className={style['field-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Due Date
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {selected?.dueDate ? dayjs(selected.dueDate).format('DD MMM, YYYY') : 'NA'}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
              <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                <img
                  className={style['field-icon']}
                  src={'/assets/link-attachment.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
                <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                  Link
                </Typography>
              </Box>
              <a
                href={selected?.link}
                style={{ textDecoration: 'none' }}
                target='_blank'
                rel='noopener noreferrer'
              >
                <Typography variant='responsiveBody2' color={zeplinColor.Brand1}>
                  {selected?.inputLink}
                </Typography>
              </a>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center',
                }}
              >
                <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                  <img
                    className={style['field-icon']}
                    src={'/assets/attachment-view.png'}
                    alt='logo'
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                    Attachment
                  </Typography>
                </Box>

                {/* {selectedFiles?.length ? (
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '8px',
                      width: '100%',
                      alignItems: 'center',
                      flex: 1,
                      justifyContent: 'flex-end',
                      cursor: 'pointer',
                    }}
                    // onClick={OnClickSubtask}
                    onClick={openInput}
                  >
                    <input
                      type='file'
                      id='attachment'
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                      disabled
                    />
                    <img
                      width={'24px'}
                      height={'24px'}
                      src={'/assets/upload-blue.svg'}
                      alt='logo'
                      style={{ objectFit: 'fill' }}
                    />
                    <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                      Select File
                    </Typography>
                  </Box>
                ) : (
                  ''
                )} */}
              </Box>
              {!selectedFiles?.length ? (
                // <CustomDragnDrop onDrop={onDrop} />
                <></>
              ) : (
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '10px', xl: '16px' } }}
                >
                  {selectedFiles.map((file, index) => (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px',
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <img
                          className={style['file-icon']}
                          src={
                            file?.name
                              ? `/assets/${file?.name
                                  ?.split('.')
                                  [file?.name?.split('.')?.length - 1].toLocaleLowerCase()}.svg`
                              : `/assets/${file
                                  ?.toString()
                                  .split('.')
                                  [
                                    file?.toString()?.split('.')?.length - 1
                                  ].toLocaleLowerCase()}.svg`
                          }
                          alt='file-type'
                          style={{ objectFit: 'fill' }}
                        />
                        <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                          <LightTooltip
                            title={
                              <Typography variant='body3' color={zeplinColor.Neutral1}>
                                {file.name}
                              </Typography>
                            }
                            placement='bottom-end'
                            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                          >
                            <Typography variant='responsiveBody2'>
                              {file?.name
                                ? file?.name?.slice(0, 40)
                                : file?.toString()?.slice(0, 40)}
                              {file?.name
                                ? file?.name?.length > 40 && '...'
                                : file?.toString()?.length > 40 && '...'}
                            </Typography>
                          </LightTooltip>
                          <Typography variant='responsiveLabel1'>
                            {file?.size ? `${file?.size / 10000}MB` : ''}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '12px',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <a
                          href={file?.toString()}
                          download={file?.toString()}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ textDecoration: 'none' }}
                        >
                          <img
                            className={style['icon']}
                            src={'/assets/download.svg'}
                            alt='logo'
                            style={{ objectFit: 'fill', cursor: 'pointer' }}
                            onClick={() => {}}
                          />
                        </a>
                        {/* <img
                          width={'20px'}
                          height={'20px'}
                          src={'/assets/vertical-dots.svg'}
                          alt='logo'
                          style={{ objectFit: 'fill', cursor: 'pointer' }}
                          onClick={() => deleteFile(index)}
                        /> */}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <Divider
              component='div'
              sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
            />
            {/* <Divider
              component='div'
              sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
            />
            <Box>
              <CustomNotes id={selected?.id} task={selected} parse_sf={parse_sf} setMsg={setMsg} />
            </Box> */}
            {/* subtask and note view */}
            {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: '8px',
                    width: '100%',
                    alignItems: 'center',
                    flex: 1,
                  }}
                >
                  
                  <Chip
                    label={
                      <Typography
                        variant='label1'
                        color={
                          selectedChip === 'Subtask' ? zeplinColor.Neutral1 : zeplinColor.BasicBlack
                        }
                        sx={{
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        Subtask
                      </Typography>
                    }
                    sx={{
                      '&:hover': {
                        backgroundColor:
                          selectedChip === 'Subtask'
                            ? zeplinColor.BasicBlack
                            : zeplinColor.Neutral3,
                      },
                      backgroundColor:
                        selectedChip === 'Subtask' ? zeplinColor.BasicBlack : zeplinColor.Neutral3,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      // width: '47px',
                      height: '40px',
                      '&.MuiChip-root': {
                        // flex: 1,
                      },
                    }}
                    onClick={() => selectChip('Subtask')}
                  />
                  <Chip
                    label={
                      <Typography
                        variant='label1'
                        color={zeplinColor.Neutral1}
                        sx={{
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        Note
                      </Typography>
                    }
                    sx={{
                      '&:hover': {
                        backgroundColor: zeplinColor.BasicBlack,
                      },
                      backgroundColor: zeplinColor.BasicBlack,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      // width: '47px',
                      height: '40px',
                      '&.MuiChip-root': {
                        // flex: 1,
                      },
                    }}
                    onClick={() => selectChip('Note')}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '8px',
                    width: '100%',
                    alignItems: 'center',
                    flex: 1,
                    justifyContent: 'flex-end',
                    cursor: 'pointer',
                  }}
                  // onClick={OnClickSubtask}
                >
                  <img
                    width={'24px'}
                    height={'24px'}
                    src={'/assets/add-blue.svg'}
                    alt='logo'
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                    Add Subtask
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center',
                  gap: '16px',
                }}
              >
                <LinearProgress
                  variant='determinate'
                  value={50}
                  sx={{ flex: 1, color: zeplinColor.Success }}
                  color='success'
                />
                <Typography variant='body3' color={zeplinColor.Success}>
                  50% Done
                </Typography>
              </Box>
              {selected?.subTask?.length
                ? selected?.subTask?.map((val: any) => <SubtaskCard data={val} loading={false} />)
                : ''}
            </Box> */}
          </Box>
        </Box>

        <Box>
          <CustomNotes id={selected?.id} task={selected} parse_sf={parse_sf} setMsg={setMsg} />
        </Box>
        <CustomModal handleClose={handleClose} open={openModal}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',
                padding: { xs: '20px', xl: '24px' },
                backgroundColor: zeplinColor.Neutral1,

                width: '312px',
                height: '201px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '22px', xl: '32px' },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '10px', xl: '16px' },
                  }}
                >
                  <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                    {markAsDone || sf_marked ? 'Mark as done' : 'Delete Task?'}
                  </Typography>
                  <Typography variant='body2' color={zeplinColor.BasicBlack}>
                    {markAsDone || sf_marked
                      ? 'Are you sure you want to mark this task as Done?'
                      : 'Are you sure you want to delete this task? This action cannot be undone.'}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',

                    gap: { xs: '10px', xl: '16px' },
                  }}
                >
                  <Box
                    onClick={handleClose}
                    sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                  >
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Neutral1,
                        border: `1px solid ${zeplinColor.BasicBlack}`,
                        cursor: 'pointer',
                        // width: '312px',
                        // height: '183px',
                        display: 'flex',
                        justifyContent: 'center',
                        flex: 1,
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                        Cancel
                      </Typography>
                    </CustomCard>
                  </Box>
                  <Box
                    onClick={() =>
                      markAsDone || sf_marked
                        ? sf_edit_selected
                          ? confirmMark(JSON.parse(sf_edit_selected))
                          : confirmMark(selected)
                        : deleteTask(selected?.id)
                    }
                    sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                  >
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Error,
                        cursor: 'pointer',
                        // border: `1px solid ${zeplinColor.BasicBlack}`,
                        // width: '312px',
                        // height: '183px',
                        display: 'flex',
                        justifyContent: 'center',
                        flex: 1,
                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                      >
                        {markAsDone || sf_marked
                          ? loading
                            ? 'Confirming'
                            : 'Confirm'
                          : loading
                          ? 'Deleting'
                          : 'Delete'}
                      </Typography>
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
            {/* {loading ? <CustomLoader /> : ''} */}
          </Box>
        </CustomModal>
      </Box>
      <CustomAlert
        open={msg.message ? true : false}
        handleClose={handleAlertClose}
        message={
          <CustomAlertContain
            alertIcon={
              msg.type === 'Error' ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={msg.message}
          />
        }
        error={msg.type === 'Error' ? true : false}
      />
    </CustomDrawer>
  );
};
export default CustomViewTask;
